import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExtFilesService } from './logic/ext-files.service';
import { ExtFilesLogicService } from './logic/ext-files/ext-files-logic.service';
import { ExtFilesDaoService } from './dao/ext-files-dao.service';
import { ExtFilesDbDaoService } from './dao/ext-files-dao/ext-files-db-dao.service';
import { ExtFileDbTableDefinition } from './dao/ext-files-dao/ext-file-db-table-definition';
import { LocalExtFileDbTableDefinition } from './dao/ext-files-dao/local-ext-file-db-table-definition';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: ExtFilesService, useClass: ExtFilesLogicService },
    {
      provide: ExtFilesDaoService,
      useClass: ExtFilesDbDaoService
    },
    { provide: ExtFileDbTableDefinition },
    { provide: LocalExtFileDbTableDefinition },
  ]
})
export class ExtFilesModule {}
